<template>
  <div class="enroll">
    <!-- <div class="banner-1">
      <img src="../../assets/common/images/banner_szzy.jpg" alt="">
    </div> -->
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">场馆预订</a>
        <span>&gt;</span>
        <a href="#">报名页</a>
      </div>
    </div> -->
    <crumbs detail="true"/>
    <div class="container">
      <div class="bookBox-1 mtb2">
        <el-form ref="enrollForm" inline-message :model="enrollForm" :rules="rules" >
          <div class="infobox clearfix">
            <div class="itembox">
              <h2>场馆信息</h2>
              <ul class="ul-form1">
                <li>
                  <label>时间：</label>
                  <el-form-item prop="time">
                    <el-input @click.stop.native="dialogTableVisible=true" v-model="enrollForm.time" placeholder="请选择时间"></el-input>
                  </el-form-item>
                </li>
                <li>
                  <label>用途：</label>
                  <el-form-item prop="touse">
                    <el-input v-model="enrollForm.touse" placeholder="请输入用途"></el-input>
                  </el-form-item>
                </li>
                <li>
                  <label>验证码：</label>
                  <el-form-item prop="checkCode">
                    <el-input v-model="enrollForm.checkCode" placeholder="请输入验证码"></el-input>
                    <!-- <img class="codeImg" src="../../assets/common/images/loginCaptcha.png" alt=""> -->
                     <img class="codeImg" :src="picCode" alt="" @click="getPicCode">
                  </el-form-item>
                </li>
              </ul>
            </div>
            <div class="itembox">
              <h2>预订信息</h2>
              <ul class="ul-form1">
                <li>
                  <label>姓名：</label>
                  <el-form-item prop="name">
                    <el-input v-model="enrollForm.name" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                </li>
                <li>
                  <label>手机号：</label>
                  <el-form-item prop="phone">
                    <el-input v-model="enrollForm.phone" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                </li>
                <li>
                  <label>身份证号：</label>
                  <el-form-item prop="IDCard">
                    <el-input v-model="enrollForm.IDCard" placeholder="请输入身份证号"></el-input>
                  </el-form-item>
                </li>
              </ul>
            </div>
          </div>
          <div class="descbox">
            <h2>预订须知</h2>
            <div class="con">
              1. 全年未入场票数达10张，将被取消当年预订资格；
              2. 如需退票，请至“我的空间-活动管理“，退票截止至活动前一天（活动当天不可退票）；
              3. 如因不可控因素导致活动无法进行，举办方有权延期或取消活动，并以短信方式通知订票人；
              4. 如参加图书馆、文化馆活动的市民，由于停车位有限，建议读者搭乘公共交通前往；
              5. 活动最终解释权归举办方所有。
            </div>
            <el-form-item>
              <el-checkbox-group v-model="enrollForm.accept" @change="bookbtnchange()">
                <el-checkbox label="我已阅读并接受预订须知相关条款。" name="accept"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <el-button class="bookbtn style1" :disabled="confirmbtnFlag" @click="submit">我要预订</el-button>
        </el-form>

      </div>
    </div>

    <el-dialog class="dialogs" width="60%" lock-scroll  :visible.sync="dialogTableVisible">
      <venuetime :id=venueId :menuId=menuId  @passTime="getPasstime"></venuetime>

     </el-dialog>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import {getSubmit} from '@/api/venue/index'
import venuetime from '@/components/venueTime/index'// 时间选择改为组件
export default {
  name: 'venueenroll',
  components: {
    venuetime,
    crumbs
  },
  meta: {
    showHeader: true
  },
  data () {
    var checkcodePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else if (!this.ifcheckTrue) {
        callback(new Error('验证码错误'))
      } else {
        callback()
      }
    }
    return {
      venueId: '',
      menuId: 6140,
      tableData: [],
      enrollForm: {
        contactIds: [],
        content: '',
        time: '',
        touse: '',
        checkCode: '',
        accept: [],
        name: '',
        phone: '',
        IDCard: ''
      },
      rules: {
        touse: [
          { required: true, message: '请填写用途', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 4, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        time: [
          { required: true, message: '请选择时间', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
          // { type: 'number', message: '必须为数字值'}, //eslint-disable-line
          // { min: 11, max: 12, type: 'number', message: '格式有误', trigger: 'blur' }
        ],
        IDCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
          // { type: 'number', message: '必须为数字值'},//eslint-disable-line
          // { min: 18, max: 18, type: 'number', message: '格式有误', trigger: 'blur' }
        ],
        checkCode: [
          //  { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: checkcodePass, trigger: 'blur' }
        ]

      },
      ifcheckTrue: true,
      confirmbtnFlag: true,
      contactsForm: {
        'name': '',
        'phone': '',
        'IDCard': ''
      },
      dialogFormVisible: false,
      dialogCompleteVisible: false,
      dialogTableVisible: false,
      addformWidth: '26%',
      completeWidth: '768px',
      picCode: ''
    }
  },
  created () {
    if (this.$cookie.get('wlyuserid') === undefined || this.$cookie.get('wlyuserid') === null) {
      this.$router.push({path: '/login', query: {redirect: this.$router.currentRoute.fullPath}})
    }
    this.menuId = this.$route.query.menuId
    this.venueId = this.$route.query.id
    // this.enrollForm.time = this.$route.query.time
  },
  mounted () {
    this.getPicCode()
    if (document.body.clientWidth < 768) {
      this.addformWidth = '80%'
      this.completeWidth = '80%'
    } else {
      this.addformWidth = '26%'
      this.completeWidth = '768px'
    }
  },
  methods: {
    submit () {
      this.$refs['enrollForm'].validate((valid) => {
        if (valid) {
          this.$confirm('确定要预订吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var phonetest = /^1(3|4|5|7|8)\d{9}$/
            var cardtest = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/
            if (!phonetest.test(this.enrollForm.phone)) {
              this.$alert('请输入正确的电话', '', {
                confirmButtonText: '确定'
              })
            } else if (!cardtest.test(this.enrollForm.IDCard)) {
              this.$alert('请输入正确的身份证号', '', {
                confirmButtonText: '确定'
              })
            } else {
              var params = {
                name: this.enrollForm.name,
                mobilePhone: this.enrollForm.phone,
                identityCard: this.enrollForm.IDCard,
                purpose: this.enrollForm.touse,
                venueId: this.venueId,
                menuId: this.menuId,
                verCode: this.enrollForm.checkCode,
                venueTime: this.enrollForm.time,
                phone: this.$cookie.get('wlymobilephone'),
                memberId: this.$cookie.get('wlyuserid')
              }
              getSubmit(params).then(res => {
                console.log(res)
                if (res.data.message !== '预订成功') {
                  this.ifcheckTrue = false
                  // eslint-disable-next-line handle-callback-err
                  this.$refs.enrollForm.validateField('checkCode', err => {
                    this.ifcheckTrue = true
                  })

            }else if(res.data.message=== "预订成功") { //eslint-disable-line
                  this.$alert('预订已提交，请等待管理员审核后生效', '', {
                    confirmButtonText: '确定',
                    callback: this.resetForm('enrollForm')
                  })
                }
              })
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        }
      })
    },
    // 重置表单数据
    resetForm (enrollForm) {
      this.$refs['enrollForm'].resetFields()
      this.$router.push({
        path: '/venue',
        query: {
          columnId: this.menuId
        }
      })
    },
    goChose () {
      this.venueId = this.$route.query.id
      var id = this.$route.query.id
      this.$router.push({
        path: '/venuetime',
        query: {
          id: id
        }
      })
    },
    getPicCode () {
      this.picCode = process.env.BASE_API + '/api/auth/jwt/getCode?' + new Date().getTime() + '&phone=' + this.$cookie.get('wlymobilephone')
    },
    changeContactIds (val) {
      this.tableData = []
      for (var i = 0; i < val.length; i++) {
        for (var j = 0; j < this.enrollForm.contactIds.length; j++) {
          if (this.enrollForm.contactIds[j] === val[i].name) {
            var obj = {
              'name': val[i].name,
              'card': val[i].contact_IDCard,
              'phone': val[i].contact_phone
            }
            this.tableData.push(obj)
          }
        }
      }
    },
    bookbtnchange () {
      console.log(this.enrollForm.accept)
      if (this.enrollForm.accept.length > 0) {
        this.confirmbtnFlag = false
      } else {
        this.confirmbtnFlag = true
      }
    },
    handleClick (val) {
      console.log(val)
      for (var i = 0; i < this.enrollForm.contactIds.length; i++) {
        if (this.enrollForm.contactIds[i] === val.name) {
          console.log(i)
          this.enrollForm.contactIds.splice(i, 1)
        }
      }
      for (var j = 0; j < this.tableData.length; j++) {
        if (this.tableData[j].name === val.name) {
          console.log(j)
          this.tableData.splice(j, 1)
        }
      }
    },
    getPasstime (value) {
      console.log(value, 'mjs')
      this.enrollForm.time = value[0]
      this.dialogTableVisible = value[1]
      this.$refs['enrollForm'].clearValidate(['time'])
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.dialogs .el-dialog .el-dialog__header{
  display: none;
}
@media screen and (max-width:1020px){
/deep/.dialogs .el-dialog{
  width: 70% !important;
}

}

</style>



// WEBPACK FOOTER //
// src/view/venue/enroll.vue